<div class="row mt-minus-50">
  <div class="col-8 offset-2 mb-3">
    <img [src]="content?.image" [alt]="content?.title" class="img-fluid d-block mx-auto rounded">
  </div>
  <div class="col-10 offset-1 text-center">
    <p [innerHTML]="content?.body"></p>
  </div>
</div>
